import {
    css,
    DefaultTheme,
    FlattenInterpolation,
    ThemeProps,
} from 'styled-components';

const _global: FlattenInterpolation<ThemeProps<DefaultTheme>> = css`
    * {
        box-sizing: border-box;
        font-family: ${({ theme }) => theme.defaults.fontFamily};
        outline: none;
    }

    html,
    body,
    #root,
    .App {
        font-family: ${({ theme }) => theme.defaults.fontFamily};
        width: 100%;
        min-width: 100vw;
        height: 100%;
        min-height: 100vh;
    }

    body {
        margin: 0;
        font-family: ${({ theme }) => theme.defaults.fontFamily};
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }

    code {
        font-family: ${({ theme }) => theme.defaults.codeFontFamily};
    }
`;

export default _global;
